import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';

/**
 * Static visual mockup of the shop inquiry panel for design review.
 * Intentionally does not submit anywhere: no fetch, no storage, no third-party
 * CAPTCHA script or test key, and no simulated success/verified state.
 */
const INTERESTS = ['Choosing tools', 'Workshops & training', 'Custom fabrication', 'Something else'];
const fieldClass = 'min-h-[44px] w-full border border-steel-200 bg-white px-3 py-2 text-[15px] text-charcoal placeholder:text-steel-400 focus:border-fred';
export function InquiryPanel() {
  return <div className="w-full border border-steel-200 bg-cream p-5 shadow-[0_24px_60px_-32px_rgba(0,0,0,0.9)] sm:p-6 lg:max-w-[400px]" data-id="element-201" data-mp="3q3da7cs4dvuc">
      <h2 className="font-display text-[28px] uppercase leading-none text-charcoal" data-id="element-202" data-mp="3uuv9lwehvod7">Talk to the shop.</h2>
      <p className="mt-2 text-[14px] leading-relaxed text-steel-600" data-id="element-203" data-mp="2xdmsyuv6ydu0">
        Questions about tools, workshops or custom metalwork? Start here.
      </p>

      <form className="mt-5 space-y-3" onSubmit={event => event.preventDefault()} data-id="element-204" data-mp="18hhh6xp40k0i">
        <div data-id="element-205" data-mp="18jbtxoq895ti">
          <label htmlFor="inquiry-name" className="mb-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-steel-600" data-id="element-206" data-mp="13io6fd17j741">
            Name
          </label>
          <input id="inquiry-name" name="name" type="text" autoComplete="name" className={fieldClass} data-id="element-207" data-mp="ypuxse2mbemo" />
        </div>

        <div data-id="element-208" data-mp="tqqq5rvcdoyg">
          <label htmlFor="inquiry-email" className="mb-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-steel-600" data-id="element-209" data-mp="pqq4bm5wybhd">
            Email
          </label>
          <input id="inquiry-email" name="email" type="email" autoComplete="email" className={fieldClass} data-id="element-210" data-mp="ktzomzy0thwh" />
        </div>

        <div data-id="element-211" data-mp="atqoxc4tlecc">
          <label htmlFor="inquiry-interest" className="mb-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-steel-600" data-id="element-212" data-mp="au8sktttauua">
            I’m interested in
          </label>
          <select id="inquiry-interest" name="interest" defaultValue={INTERESTS[0]} className={fieldClass} data-id="element-213" data-mp="257qj8ppik7tj">
            {INTERESTS.map(option => <option key={option} value={option} data-id="element-214" data-mp="3hstmrp87e4l">
                {option}
              </option>)}
          </select>
        </div>

        <div data-id="element-215" data-mp="3ppsp4paz4qji">
          <label htmlFor="inquiry-message" className="mb-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-steel-600" data-id="element-216" data-mp="3pq2cs68jqlm1">
            How can we help?
          </label>
          <textarea id="inquiry-message" name="message" rows={2} className={`${fieldClass} resize-y`} data-id="element-217" data-mp="3umj6rh2ffu71" />
        </div>

        {/* Static verification box — visual only, never a real or passed CAPTCHA. */}
        <div aria-hidden="true" className="flex items-center gap-3 border border-steel-200 bg-white px-3 py-2.5" data-id="element-218" data-mp="d8dy2vrkzcvf">
          <span className="h-5 w-5 shrink-0 border border-steel-400 bg-cream" data-id="element-219" data-mp="h8o428fdi3aa" />
          <span className="text-[14px] text-charcoal" data-id="element-220" data-mp="2xyd42zp2fbve">I’m not a robot</span>
          <ShieldCheckIcon className="ml-auto h-5 w-5 text-steel-400" data-id="element-221" data-mp="320813rzyr33d" />
        </div>

        <button type="button" aria-disabled="true" className="mt-1 flex min-h-[48px] w-full items-center justify-center bg-fred px-6 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-fred-dark" data-id="element-222" data-mp="31xveh1j9g4jz">
          Send Inquiry
        </button>
      </form>
    </div>;
}